import React from 'react';
import { Avatar, Box, Typography } from '@mui/material';

import { getLoggedInUser, getUserEmail } from '@paragon/login-tools';

import { useAppSelector } from '../hooks';

export function InformationCard() {
  const userEmail = useAppSelector((state) => getUserEmail(state));
  const loggedInUser = useAppSelector((state) => getLoggedInUser(state))!;

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        bgcolor: 'backContrast.main',
        p: 2,
        mb: 2,
      }}
    >
      <Typography variant="subtitle1">{loggedInUser.organization}</Typography>
      <Avatar
        sx={{
          m: 1,
          color: '#fff',
          fontSize: '2.5em',
          bgcolor: 'avatar.main',
          width: 75,
          height: 75,
        }}
      >{`${loggedInUser.firstName.slice(0, 1)}${loggedInUser.lastName.slice(0, 1)}`}</Avatar>
      <Typography variant="subtitle1">{`${loggedInUser.firstName} ${loggedInUser.lastName}`}</Typography>
      <Typography variant="caption">{userEmail}</Typography>
    </Box>
  );
}
